import { Action, Selector, State, StateContext, Store } from '@ngxs/store'
import { inject, Injectable } from '@angular/core'
import { AppActions } from './app.actions'
import { Observable } from 'rxjs'
import SignIn = AppActions.SignIn
import SignOut = AppActions.SignOut
import AuthRefresh = AppActions.AuthRefresh
import SaveAuthReturnUrl = AppActions.SaveAuthReturnUrl
import { AuthSession } from '../model/app.model'

export interface AppStateModel {
	auth: {
		isAuthenticated: boolean
		session: AuthSession | undefined
		returnUrl: string | undefined
	}
}

@State<AppStateModel>({
	name: 'app',
	defaults: {
		auth: {
			isAuthenticated: false,
			session: void 0,
			returnUrl: void 0,
		}
	},
	children: [],
})
@Injectable()
export class AppState {
	state$: Observable<AppStateModel> = inject(Store).select(AppState.APP)

	@Selector()
	static APP(state: AppStateModel) {
		return state
	}

	@Selector()
	static auth(state: AppStateModel) {
		return state.auth
	}

	@Action(SignIn)
	signIn(ctx: StateContext<AppStateModel>, action: SignIn) {
		const state = ctx.getState()
		ctx.patchState({
			auth: {
				isAuthenticated: true,
				session: action.authSession,
				returnUrl: state.auth.returnUrl,
			},
		})
	}

	@Action(SignOut)
	signOut(ctx: StateContext<AppStateModel>) {
		ctx.patchState({
			auth: {
				isAuthenticated: false,
				session: void 0,
				returnUrl: void 0,
			},
		})
	}

	@Action(AuthRefresh)
	authRefresh(ctx: StateContext<AppStateModel>, action: SignIn) {
		const state = ctx.getState()
		ctx.patchState({
			auth: {
				isAuthenticated: true,
				session: action.authSession,
				returnUrl: state.auth.returnUrl,
			},
		})
	}

	@Action(SaveAuthReturnUrl)
	saveAuthReturnUrl(ctx: StateContext<AppStateModel>, action: SaveAuthReturnUrl) {
		const state = ctx.getState()
		ctx.patchState({
			auth: {
				...state.auth,
				returnUrl: action.returnUrl,
			},
		})
	}
}
